import { AuthLayout } from '@ui/components/layouts';
import { ForgotPasswordContainer } from '@modules/forgot-password/containers/forgot_password_container';
import { ForgotPasswordForm } from '@modules/forgot-password/views/forgot_password_view';
import { AuthPublicPageContainer } from '@/src/components/AuthPublicPageContainer';
import { webAppRoutes } from '@/src/lib/navigation/containerPaths';

export function ForgotPasswordScreen() {
  return (
    <AuthPublicPageContainer>
      {({ onSuccess, onError, onSuccessNavigate, navigate }) => (
        <AuthLayout>
          <ForgotPasswordContainer
            View={ForgotPasswordForm}
            onSuccess={onSuccess}
            onError={onError}
            onSuccessNavigate={onSuccessNavigate}
            onNavigateToLogin={() => navigate(webAppRoutes.login)}
            useFormSubmitHandler
          />
        </AuthLayout>
      )}
    </AuthPublicPageContainer>
  );
}
